import React from 'react';
import { cn } from './cn';

function Table({ className, ...props }) {
  return (
    <div className="ui-table-wrap">
      <table className={cn('ui-table', className)} {...props} />
    </div>
  );
}

function TableHeader({ className, ...props }) {
  return <thead className={cn('ui-table-header', className)} {...props} />;
}

function TableBody({ className, ...props }) {
  return <tbody className={cn('ui-table-body', className)} {...props} />;
}

function TableRow({ className, ...props }) {
  return <tr className={cn('ui-table-row', className)} {...props} />;
}

function TableHead({ className, ...props }) {
  return <th className={cn('ui-table-head', className)} {...props} />;
}

function TableCell({ className, ...props }) {
  return <td className={cn('ui-table-cell', className)} {...props} />;
}

export { Table, TableHeader, TableBody, TableRow, TableHead, TableCell };
